import { render } from "./lgpd.vue?vue&type=template&id=50019c2f&scoped=true"
import script from "./lgpd.vue?vue&type=script&lang=js"
export * from "./lgpd.vue?vue&type=script&lang=js"

import "./lgpd.vue?vue&type=style&index=0&id=50019c2f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50019c2f"]])

export default __exports__